"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InvalidStateAccessorError = exports.AccessorType = exports.aggregateGroupableEvents = exports.Placement = exports.isTransactionMetaEvent = exports.isMetaEvent = exports.idFromEvent = exports.isDBRef = exports.TOTAL = exports.UNASSIGNED_PLAYER = void 0;
var tslib_1 = require("tslib");
var _ = tslib_1.__importStar(require("underscore"));
exports.UNASSIGNED_PLAYER = 'unassigned';
exports.TOTAL = 'total';
function isDBRef(obj) {
    return _.has(obj, '$id') && _.has(obj, '$ref');
}
exports.isDBRef = isDBRef;
function idFromEvent(event) {
    if (event === undefined) {
        return undefined;
    }
    else if (event['_id'] !== undefined) {
        return event['_id'];
    }
    else if (event['id'] !== undefined) {
        return event['id'];
    }
    return undefined;
}
exports.idFromEvent = idFromEvent;
function isMetaEvent(event) {
    return (event.hasOwnProperty('code') &&
        _.contains(['insert', 'delete', 'replace', 'transaction', 'edit_group', 'undo', 'redo'], event.code));
}
exports.isMetaEvent = isMetaEvent;
function isTransactionMetaEvent(event) {
    return event.hasOwnProperty('code') && event.code === 'transaction';
}
exports.isTransactionMetaEvent = isTransactionMetaEvent;
// EditGroup helpers
var Placement;
(function (Placement) {
    Placement[Placement["Before"] = 0] = "Before";
    Placement[Placement["After"] = 1] = "After";
})(Placement = exports.Placement || (exports.Placement = {}));
function aggregateGroupableEvents(events) {
    var accum = {
        deleteIds: [],
        insertions: [],
    };
    for (var _i = 0, events_1 = events; _i < events_1.length; _i++) {
        var event_1 = events_1[_i];
        accumulate(event_1, accum);
    }
    return accum;
}
exports.aggregateGroupableEvents = aggregateGroupableEvents;
function accumulate(event, accum) {
    var _a, _b;
    switch (event.code) {
        case 'insert':
            if (event.beforeId) {
                accum.insertions.push([event.beforeId, Placement.Before, event.events]);
            }
            else if (event.afterId) {
                accum.insertions.push([event.afterId, Placement.After, event.events]);
            }
            else {
                throw new Error('need before/after id');
            }
            break;
        case 'delete':
            (_a = accum.deleteIds).push.apply(_a, event.deleteIds);
            break;
        case 'replace':
            if (event.deleteIds.length === 0) {
                throw new Error('need deletes in a replace');
            }
            (_b = accum.deleteIds).push.apply(_b, event.deleteIds);
            accum.insertions.push([event.deleteIds[0], Placement.After, event.events]);
            break;
        case 'edit_group':
            for (var _i = 0, _c = event.events; _i < _c.length; _i++) {
                var subevent = _c[_i];
                accumulate(subevent, accum);
            }
            break;
        default:
            break;
    }
}
var AccessorType;
(function (AccessorType) {
    AccessorType[AccessorType["Latest"] = 0] = "Latest";
    AccessorType[AccessorType["Before"] = 1] = "Before";
    AccessorType[AccessorType["After"] = 2] = "After";
})(AccessorType = exports.AccessorType || (exports.AccessorType = {}));
var InvalidStateAccessorError = /** @class */ (function (_super) {
    tslib_1.__extends(InvalidStateAccessorError, _super);
    function InvalidStateAccessorError(accessorType, eventId) {
        var _this = _super.call(this, "Could not find ".concat(eventId, " for accessor ").concat(accessorType, ".")) || this;
        _this.name = 'InvalidStateAccessorError';
        return _this;
    }
    return InvalidStateAccessorError;
}(Error));
exports.InvalidStateAccessorError = InvalidStateAccessorError;
//# sourceMappingURL=definitions.js.map